import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { PeriodService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PeriodCreateDto,
  PeriodDto,
  PeriodExcelDownloadDto,
  PeriodUpdateDto,
} from '../proxy/controlling/dtos/period';
import { PERIOD_CONFIG, PERIOD_FIELDS } from './period.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-period',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, PeriodService, ConfirmationService],
  templateUrl: './period.html',
  styleUrl: './period.scss',
})
export class Period extends BaseCrudComponent<
  PeriodDto,
  PeriodCreateDto,
  PeriodUpdateDto,
  PeriodExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(PeriodService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('Period', ids),
  };
  config = PERIOD_CONFIG;
  fields = PERIOD_FIELDS;

  protected prepareUpdateDto(data: any, selected: PeriodDto): PeriodUpdateDto {
    return {
      name: data.name,
      month: data.month,
      year: data.year,
      stockStartDate: data.stockStartDate,
      stockEndDate: data.stockEndDate,
      liquidationStartDate: data.liquidationStartDate,
      liquidationEndDate: data.liquidationEndDate,
      isStockActive: data.isStockActive,
      isLiquidationActive: data.isLiquidationActive,
      isActivityReportIntegrationActive: data.isActivityReportIntegrationActive,
      isMm4InterfaceActive: data.isMm4InterfaceActive,
      isWoodValorizationClosed: data.isWoodValorizationClosed,
      periodTypeId: data.periodTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Period';
  }
}
